import * as THREE from 'three';
import Action from '../classes/Action';
import { CustomEventTypes } from '../globals';
import ARTracker from '../classes/ARTracker';

type modelIdentifier = string | THREE.Object3D[];

export default class SetModelTrackerModelAction extends Action
{
	constructor(trackers: ARTracker[], newValue: modelIdentifier)
	{
		const actionName = "Set AR Tracker Model";
		const isModelAssetId = (typeof newValue === 'string');
		const oldValues: modelIdentifier[] = [];
		const trackerPositions: THREE.Vector3[] = [];
		const trackerRotations: THREE.Euler[] = [];

		for (let i = 0; i < trackers.length; i++)
		{
			trackerPositions.push(new THREE.Vector3().copy(trackers[i].position));
			trackerRotations.push(new THREE.Euler().copy(trackers[i].rotation));

			if (trackers[i].getSceneSelectionModels().length)
			{
				oldValues.push([...trackers[i].getSceneSelectionModels() as THREE.Object3D[]]);
			}
			else
			{
				oldValues.push(trackers[i].getModelAssetId());
			}
		}

		super(
			[isModelAssetId, trackers, newValue],
			[trackers, oldValues, trackerPositions, trackerRotations],
			actionName,
			[isModelAssetId, trackers, newValue, oldValues]);
	}

	do(isModelAssetId: boolean, trackers: ARTracker[], value: modelIdentifier)
	{
		for (let i = 0; i < trackers.length; i++)
		{
			const tracker = trackers[i];
			if (isModelAssetId)
			{
				tracker.setModel(value as string);
			}
			else
			{
				tracker.setModelFromSceneSelection(value as THREE.Object3D[]);
			}
		}

		document.dispatchEvent(new CustomEvent(CustomEventTypes.updateTrackerComponent));
		document.dispatchEvent(new CustomEvent(CustomEventTypes.selectedObjectPositionChanged));
		document.dispatchEvent(new CustomEvent(CustomEventTypes.selectedObjectRotationChanged));
	}

	undo(trackers: ARTracker[], values: modelIdentifier[], positions: THREE.Vector3[], rotations: THREE.Euler[])
	{
		for (let i = 0; i < trackers.length; i++)
		{
			const isModelAssetId = (typeof values[i] === 'string');
			const tracker = trackers[i];
			if (isModelAssetId || !values[i])
			{
				tracker.setModel(values[i] as string);
				tracker.position.copy(positions[i]);
				tracker.rotation.copy(rotations[i]);
			}
			else
			{
				tracker.setModelFromSceneSelection(values[i] as THREE.Object3D[]);
			}
		}

		document.dispatchEvent(new CustomEvent(CustomEventTypes.updateTrackerComponent));
		document.dispatchEvent(new CustomEvent(CustomEventTypes.selectedObjectPositionChanged));
		document.dispatchEvent(new CustomEvent(CustomEventTypes.selectedObjectRotationChanged));
	}

	verify(isModelAssetId: boolean, trackers: ARTracker[], newValue: modelIdentifier, oldValues: modelIdentifier[])
	{
		if(!trackers.length) return false;
		if(!isModelAssetId) return true;

		for(const value of oldValues)
		{
			if(value !== newValue) return true;
		}
	
		return false;
	}
}
